<script setup lang="ts">
import { onMounted } from 'vue'

import { useAuthStore } from '@/stores/auth.stores'

const authStore = useAuthStore()

onMounted(async () => {
  const logoutUrl = await authStore.logout()
  window.location.href = logoutUrl
})
</script>
<template>
  <div></div>
</template>
